export { default } from './AssemblyOneCell';
